import {Component, OnInit, ViewChild} from '@angular/core';
import {
    ConfiguratorEtlService,
    ConfiguratorTableService,
    EngineEtlService,
    EtlFilterDTO,
    FtpClient,
    SharedFileExtractConf
} from '@tj/tj-dmp-lib-api';
import {AbstractEtlUpdateComponent} from '../abstract-etl-update.component';
import {Router} from '@angular/router';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FileServerConfigComponent} from '../../../../components/file-server-config/file-server-config.component';

@Component({
    selector: 'dmp-etl-update-process',
    templateUrl: './etl-update-process.component.html',
    standalone: false
})
export class EtlUpdateProcessComponent extends AbstractEtlUpdateComponent implements OnInit {
    @ViewChild(FileServerConfigComponent) fileServerConfigComponent: FileServerConfigComponent;

    sharedFile: SharedFileExtractConf = null;
    /** Affiliés du job : ils déterminent les connexions enregistrées proposées. */
    jobPartners: string[] = [];
    filterDTO: EtlFilterDTO;

    isFtp = false;
    testFtpEnCours = false;
    messageRetourTestFtp: string;
    newSharedFile: SharedFileExtractConf;
    disabledButtonSaveAction = true;

    constructor(
        protected configuratorEtlService: ConfiguratorEtlService,
        protected tableResourceService: ConfiguratorTableService,
        protected router: Router,
        protected confirmationService: ConfirmationService,
        protected messageService: MessageService,
        protected translate: TranslateService,
        protected engineEtlService: EngineEtlService) {
        super(router, confirmationService, translate);
    }

    ngOnInit() {
        this.configuratorEtlService.getFilterUsingGET(this.tenant, this.id).subscribe(filterDTO => {
            this.filterDTO = filterDTO;
            this.completChange.emit(filterDTO.complet);
            this.sharedFile = filterDTO.extract as SharedFileExtractConf;
            this.isFtp = !!this.sharedFile && !!this.sharedFile.confFtp;
        });
        this.configuratorEtlService.getEtlByIdUsingGET(this.tenant, this.id).subscribe(etl => {
            this.jobPartners = [...new Set([...(etl.partner ? [etl.partner] : []), ...(etl.personalDataAccessPartners ?? [])])];
        });
    }

    changeFtpMode(event: any) {
        if (event.checked) {
            this.sharedFile.confFtp = {
                ftps: false,
                host: '',
                implicite: false,
                login: '',
                passive: false,
                password: ''
            } as FtpClient;
            this.sharedFile.patternFileNameWithDate = false;
            this.sharedFile.fileName = '';
            this.sharedFile.cron = null;
        } else {
            this.sharedFile.confFtp = null;
            this.sharedFile.patternFileNameWithDate = false;
            this.sharedFile.fileName = '';
        }
    }

    save(b: boolean) {
        // Vérifier si l'action est autorisée
        if (this.disabledButtonSaveAction) {
            return;
        }

        this.filterDTO.extract = this.fileServerConfigComponent.getConfiguration();
        this.filterDTO.load = null;
        this.configuratorEtlService.updateProcessUsingPOST(this.tenant, this.filterDTO).subscribe(res => {
            this.nextStep.emit({ uuid: this.id });
        });
    }

    isValid() {
        return this.sharedFile !== null && (this.sharedFile.confFtp == null ||
            this.sharedFile.confFtp.host && this.sharedFile.confFtp.host.trim().length > 1);
    }

    doCheckFtpConf() {
        this.messageRetourTestFtp = null;
        this.testFtpEnCours = true;
        const value = JSON.parse(JSON.stringify(this.sharedFile.confFtp));
        value.typeObject = 'FtpStoreConf';
        this.engineEtlService.checkConfigFtpUsingPOST(value, this.tenant, this.id, 'response',).subscribe(res => {
            this.messageRetourTestFtp = res.body.message;
            this.testFtpEnCours = false;
            if (this.messageRetourTestFtp === "Ok") {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Succès',
                    detail: "Connexion au serveur FTP réussie."
                });
            }
            else {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Erreur',
                    detail: this.messageRetourTestFtp
                });
            }
        }, error => {
            this.testFtpEnCours = false;
            this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: "Timeout",
            });
        });

    }
}
